import { useTranslation } from "react-i18next";

import { SettingsSection } from "../../UserMember/SettingsSection";
import { ClubForm } from "./ClubForm";
import { CompanyForm } from "./CompanyForm";
import { MarketingForm } from "./MarketingForm";

export function ClubInfo() {
  const { t } = useTranslation();

  return (
    <div className="-mx-4 flex max-h-full flex-col overflow-y-auto px-4 lg:-mx-8 lg:px-8">
      <div className="relative flex size-full max-h-full flex-col">
        <div className="-mt-4 flex flex-col pb-48">
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title={t("page.settings.tab.club.clubInfo.clubInformation")}
              subTitle={t("page.settings.tab.club.clubInfo.updateInformation")}
            />
            <SettingsSection.Content>
              <ClubForm />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title={t("page.settings.tab.club.clubInfo.companyInformation")}
              subTitle={t("page.settings.tab.club.clubInfo.updateInvoices")}
            />
            <SettingsSection.Content>
              <CompanyForm />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title={t("page.settings.tab.club.clubInfo.marketingOptIn")}
              subTitle={t("page.settings.tab.club.clubInfo.manageOptIn")}
            />
            <SettingsSection.Content>
              <MarketingForm />
            </SettingsSection.Content>
          </SettingsSection.Container>
        </div>
      </div>
    </div>
  );
}
